export var BusinessInvoiceStatus;
(function (BusinessInvoiceStatus) {
    BusinessInvoiceStatus["Draft"] = "DRAFT";
    BusinessInvoiceStatus["Sent"] = "SENT";
    BusinessInvoiceStatus["Viewed"] = "VIEWED";
    BusinessInvoiceStatus["Paid"] = "PAID";
    BusinessInvoiceStatus["PartiallyPaid"] = "PARTIALLY_PAID";
    BusinessInvoiceStatus["Overdue"] = "OVERDUE";
    BusinessInvoiceStatus["Cancelled"] = "CANCELLED";
})(BusinessInvoiceStatus || (BusinessInvoiceStatus = {}));
//# sourceMappingURL=BusinessInvoiceStatus.js.map